<script lang="ts" setup>
import LoadingSpinnerIcon from '@shared/component/LoadingSpinnerIcon/LoadingSpinnerIcon.vue';
import type { ItemLinkProps } from './types';

const props = defineProps<ItemLinkProps>();
</script>

<template>
  <a
    v-bind="props.menuRouterBindProps.action"
    class="gap-2"
    :href="props.menuItem.url"
    :target="props.menuItem.target"
  >
    <LoadingSpinnerIcon v-if="props.menuItem.loading" fixed-width />

    <i v-else v-bind="props.menuRouterBindProps.icon"></i>

    <span v-bind="props.menuRouterBindProps.label">{{ props.menuItem.label }}</span>
  </a>
</template>
